// Cosmetic cues come only from structured stream tool IDs, never user text.
// A client on the line (frontdesk/liveCall.js): the handset goes to the ear.
const CALL_TOOLS = new Set(['front_desk_call']);
const PHONE_TOOLS = new Set(['draft_campaign', 'send_campaign', 'draft_journey', 'draft_offer', 'preview_offer', 'marketable_audience', 'comms_state', 'credits_balance']);
const DIARY_TOOLS = new Set(['diary_week', 'propose_booking', 'propose_event', 'propose_time_off', 'set_working_day', 'book_time_off', 'block_time', 'booking_rules']);
export function getBaileyActivity(state, tool) {
    if (state !== 'working') return 'none';
    if (CALL_TOOLS.has(tool)) return 'call';
    if (PHONE_TOOLS.has(tool)) return 'phone';
    if (DIARY_TOOLS.has(tool)) return 'diary';
    return 'laptop';
}
export const ACTIVITY_LABELS = { laptop: 'Working at the laptop', phone: 'Checking messages on the phone', diary: 'Checking the diary at the desk', call: 'On the phone with a client' };
